import { API_BASE } from './apiBase';

async function request<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = localStorage.getItem('auth_token');

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string>) || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  let res: Response;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      ...options,
      headers,
    });
  } catch {
    throw new Error('Server nicht erreichbar. Bitte versuchen Sie es später erneut.');
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    let message = body.message || `Fehler: ${res.status}`;
    if (Array.isArray(message)) message = message[0];
    if (typeof message === 'string' && message.startsWith('Cannot ')) {
      message = 'Der Server konnte die Anfrage nicht verarbeiten. Bitte versuchen Sie es später erneut.';
    }
    if (typeof message === 'string' && (message === 'Internal Server Error' || res.status === 500)) {
      message = 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
    }
    throw new Error(message);
  }

  const text = await res.text();
  if (!text) return undefined as T;
  return JSON.parse(text);
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(data) }),
  patch: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: 'PATCH', body: JSON.stringify(data) }),
  put: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(data) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
